import React from "react";
import { FAQS } from "../../data/content";
import { FaqItem } from "../FaqItem";
export function Faq() {
  return <section className="bg-neutral-950 py-16 px-4 border-t border-neutral-900" data-id="element-72" data-mp="1c1kmrmkmn9v6">
      <div className="max-w-3xl mx-auto" data-id="element-73" data-mp="x4bsol3xvrzr">
        <h2 className="font-display text-3xl sm:text-5xl text-white text-center uppercase mb-10" data-id="element-74" data-mp="x5d62w8fgqkn">
          ❓ Lo que más <span className="text-[#e10600]" data-id="element-75" data-mp="124g9ydco8qr1">nos preguntan</span>
        </h2>
        <div className="space-y-3" data-id="element-76" data-mp="1psppwyn7eka9">
          {FAQS.map(f => <FaqItem key={f.q} question={f.q} answer={f.a} data-id="element-77" data-mp="1urk7jx9fq2ss" />)}
        </div>
      </div>
    </section>;
}